module.exports = __webpack_public_path__ + "img/4287e7201adf48ef8ab54004c2ac761c.575941b5.png";